import { EmploymentType, RemunerationType } from '$constants'
import { Nullable, StaffMemberRole, transformMemberRolesOnSave } from '$models'
import dayjs, { Dayjs } from 'dayjs'
import { getDateStringWithoutTimeZone } from 'src/components/routes/_common/helpers'
import sortBy from 'lodash/sortBy'

export interface StaffMemberRemunerationSnapshot {
  id?: string
  isActiveRemuneration: boolean
  staffMemberId: string
  defaultRoleId: string
  validFrom: Dayjs
  validTo: Nullable<Dayjs>
  type: RemunerationType
  salaryRate: number
  employmentType?: EmploymentType
  weeklyContractedHours?: number
  memberRoles: StaffMemberRole[]
  datestampDeleted?: Nullable<Dayjs>
}

// Function to apply transformations to RemunerationSnapshot object on save
export const transformRemunerationSnapshotOnSave = (
  remunerationSnapshot: StaffMemberRemunerationSnapshot
): object => {
  return {
    ...remunerationSnapshot,
    validFrom: getDateStringWithoutTimeZone(remunerationSnapshot.validFrom),
    validTo:
      remunerationSnapshot.validTo != null
        ? getDateStringWithoutTimeZone(remunerationSnapshot.validTo)
        : remunerationSnapshot.validTo,
    memberRoles: remunerationSnapshot.memberRoles.map(
      transformMemberRolesOnSave
    ),
  }
}

// Function to apply transformations to RemunerationSnapshot object on get
export const transformRemunerationSnapshotOnGet = (
  remunerationSnapshot: StaffMemberRemunerationSnapshot
): StaffMemberRemunerationSnapshot => {
  return {
    ...remunerationSnapshot,
    memberRoles: sortBy<StaffMemberRole>(
      remunerationSnapshot.memberRoles,
      'roleName'
    ),
    validFrom: dayjs.utc(remunerationSnapshot.validFrom),
    validTo:
      remunerationSnapshot.validTo != null
        ? dayjs.utc(remunerationSnapshot.validTo)
        : null,
  }
}

export const sortRemunerationSnapshot = (
  remunerationSnapshots: StaffMemberRemunerationSnapshot[]
): StaffMemberRemunerationSnapshot[] => {
  return sortBy(remunerationSnapshots, (snapshot) => {
    // Check if validTo dates are null or undefined
    if (snapshot.validTo == null) {
      // Place null values first
      return Number.NEGATIVE_INFINITY
    } else {
      // Sort by validTo dates in ascending order
      return -dayjs.utc(snapshot.validTo).valueOf()
    }
  })
}
